import { render, staticRenderFns } from "./Productive.vue?vue&type=template&id=b110a566&"
import script from "./Productive.vue?vue&type=script&lang=js&"
export * from "./Productive.vue?vue&type=script&lang=js&"
import style0 from "./Productive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports